import { UI_SHIFT_PROJECT } from "@/modules/unleash/flags"
import { useFlag } from "@/modules/unleash/hooks/useFlag"

export const useUIShift = (): boolean => useFlag(UI_SHIFT_PROJECT)
